module.exports = __webpack_public_path__ + "static/media/bell.5f0f2ed2.svg";